<template>
  <div class="py-4 container-fluid">
    <div class="row">
      <div class="col-12">
        <businesslocation-form :itemId="id" formType="Edit" subTitle="Edit Business Location"></businesslocation-form>
      </div>
    </div>
  </div>
</template>

<script>
import BusinesslocationForm from "@/views/businesslocation/components/Form.vue";

export default {
  name: "edit-businesslocation",
  data(){
    return {
      id : this.$route.params.id
    }
  },
  components: {
    BusinesslocationForm,
  }
};
</script>